import { TabletsDeCuenta, RUTAS_MIS_TABLETS } from '../componentes/tablets-sede.js';
import { useSesion } from '../servicios/sesion.js';

/**
 * Tablets de la propia cuenta de sede. Desde aquí se genera el QR para emparejar una tablet nueva
 * y se ve el historial de cada tablet de la cuenta. No muestra nada de otras cuentas.
 */
export function MisTablets(): JSX.Element {
  const { usuario } = useSesion();

  return (
    <>
      <div className="cabecera-pagina">
        <div>
          <h1>Mis tablets</h1>
          <p className="campo-nota">
            Tablets de esta cuenta de sede y quién tiene asignada cada una. Genere aquí el QR para emparejar una tablet nueva.
          </p>
        </div>
      </div>

      <section className="panel">
        <div className="panel-cuerpo">
          <TabletsDeCuenta rutas={RUTAS_MIS_TABLETS} clave={usuario?.id ?? 'mis-tablets'} esAdmin={false} />
        </div>
      </section>
    </>
  );
}
